import type {Code, CodeList} from 'services/codelists/types';
import type {ManifestationImportProps} from 'services/metadata/types';
import {isNullish} from 'schemaDefinition';
import {
  isInvalidDagbokorNotatbok,
  isInvalidKalender,
  isKart,
} from './productFormDetailRestrictions';

// Exclude options
const excludedProductForms = (productForm: string): boolean => {
  return [
    'PZ', // Andre trykte artikler
    'PM', // Mappe
    'PK', // Plakat
    'PA', // Diverse trykk
  ].includes(productForm);
};

// Include options.
const matchingFirstLetter = (code: Code, productForm: string): boolean => {
  return code.code[0] === productForm[0];
};

const isEbokOgBlokkbokstaver = (code: Code, productForm: string): boolean => {
  return productForm === 'ED' && code.code === 'B611';
};

export function getRestrictedProductFormDetailCodelist(
  {manifestation: {productForm}}: ManifestationImportProps,
  codelist: CodeList,
): CodeList {
  return isNullish(productForm)
    ? codelist
    : {
        ...codelist,
        codes: codelist.codes.map(item => {
          // Matching first letter
          const include =
            matchingFirstLetter(item, productForm) ||
            // Or Ebok and Blokkbokstaver
            isEbokOgBlokkbokstaver(item, productForm) ||
            // Or map
            isKart(item, productForm);

          const excluded =
            // Always exclude these productforms
            excludedProductForms(productForm) ||
            isInvalidDagbokorNotatbok(item, productForm) ||
            isInvalidKalender(item, productForm);

          return include && !excluded ? item : {...item, disabled: true};
        }),
      };
}
